import React, {Fragment, useContext} from 'react'
import './ContactInfo.less';
import {ListSplitter} from "elements/list-splitter/ListSplitter.tsx";
import {InfoItem} from "compositions/info-item/InfoItem";
import {InfoItemValue} from "elements/info-item-value/InfoItemValue";
import {BlockDescription} from "elements/block-description/BlockDescription";
import {GeolocationLink} from "elements/geolocation-link/GeolocationLink";
import {PhoneLink} from "elements/phone-link/PhoneLink";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const ContactInfo = ({phone, latitude, longitude, contactUsText, address, zip, website}) => {
	const translations = useContext(TranslationsContext);

	return <div className="contact-info">
		{
			contactUsText && (<div className="contact-info__description">
				<BlockDescription text={contactUsText}/>
			</div>)
		}
		<ul className="contact-info__contacts">
			{
				phone && (<li className="contact-info__contact" key="phone">
					<PhoneLink
						phone={phone}
					>
						<InfoItem
							label={getSafeTranslation('ContactInfo.phoneLabel', translations)}
							control={
								<InfoItemValue text={phone} isBold/>
							}
						/>
					</PhoneLink>
				</li>)
			}
			{
				phone && (address || website) && (<ListSplitter key="splitter-1"/>)
			}

			{
				address && (<li className="contact-info__contact" key="address">
					<GeolocationLink
						latitude={latitude}
						longitude={longitude}
						address={address}
						zip={zip}
					>
						<InfoItem
							label={getSafeTranslation('ContactInfo.addressLabel', translations)}
							control={
								<InfoItemValue text={address} isBold/>
							}
						/>
					</GeolocationLink>
				</li>)
			}
			{
				(phone || address) && website && (<ListSplitter key="splitter-2"/>)
			}
			{
				website && (<li className="contact-info__contact" key="website">
						<InfoItem
							label={getSafeTranslation('ContactInfo.websiteLabel', translations)}
							control={
								<InfoItemValue text={website} isBold/>
							}
						/>
					</li>
				)
			}

		</ul>
	</div>
}
